import { DateFormatter } from '@components'

import { Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

import { getPassedTimeText } from '../../../../../../utils/getPassedTimeText'

interface InvoicePaymentPaneExtraProps {
  date: string | null
  status: InvoiceStatus
}

export const InvoicePaymentPaneExtra = ({ date, status }: InvoicePaymentPaneExtraProps): ReactElement | null => {
  const { t } = useTranslation()

  if (date) {
    if (status === InvoiceStatus.Paid || status === InvoiceStatus.Draft) {
      return (
        <Text colorVariant="secondary" variant="bodySM">
          <DateFormatter value={date} />
        </Text>
      )
    }

    if (status === InvoiceStatus.Unpaid) {
      return (
        <>
          <Text colorVariant="secondary" variant="bodySM">
            {t('invoices.view.payment_pane.due')}
          </Text>
          <Text colorVariant="secondary" variant="bodySM">
            <DateFormatter value={date} />
          </Text>
        </>
      )
    }

    if (status === InvoiceStatus.Overdue) {
      const passedTimeText = getPassedTimeText(date, t)

      return (
        <Text variant="bodySM" colorVariant="danger" truncate>
          {passedTimeText}
        </Text>
      )
    }
  }

  return null
}
